/**
 * Navigation
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '../../../shared/utils/scroll';

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from '../../../shared/dom/manipulator';
import EventHandler from '../../../shared/dom/event-handler';

import Nav from '../../../shared/components/nav';
import Drawer from '../../../shared/components/drawer';
import {isElement} from '../../../shared/utils/is';
import {getInlineConfig} from '../../utils';

// -------
// Private
// -------

const NAME      = 'menu';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

const pageMenu = SelectorEngine.findOne('#page-menu-drawer');

/**
 * Drawer (Navigationsoverlay)
 */
const setupDrawer = () => {
	const trigger = SelectorEngine.findOne('[aria-controls="page-menu-drawer"]');
	const drawer  = new Drawer(pageMenu, {
		// onInit   : (event) => {
		// 	const componentCloseButton = SelectorEngine.findOne('.drawer__header > .drawer-close', event.target);
		//
		// 	if (componentCloseButton) {
		// 		componentCloseButton.remove();
		// 	}
		// },
		onShow   : function() {
			Manipulator.addClass(trigger, '-active');
		},
		onHidden : () => {
			Manipulator.removeClass(trigger, '-active');
		}
	});

	EventHandler.on(trigger, 'click.ifab.pageMenuDrawer', (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.delegateTarget.classList.contains('-active')) {
			drawer.hide();
		} else {
			drawer.show();
		}
	});
};

/**
 * Initialisierung der eigentlichen Navigationsliste.
 */
const navigation = () => {
	const nav    = SelectorEngine.findOne('#main-nav', pageMenu);
	const config = getInlineConfig('nav-slider', pageMenu);

	if(!nav) {
		return;
	}

	Manipulator.addClass(nav, 'slide-menu');

	const slideNav = new SlideMenu(nav, {
		backLinkBefore  : '<i class="far fa-chevron-left"></i>',
		submenuLinkAfter: '<i class="far fa-chevron-right"></i>',
		media           : config
	});

	EventHandler.on(nav, 'click', '.nav-link.-has-sub', (event) => {
		event.preventDefault();
		event.stopPropagation();

		const link   = event.delegateTarget;
		const target = event.target;
		const pageId = Manipulator.getDataAttribute(link, 'page');

		// if(target.classList.contains('slide-menu__decorator')) {
		let navItem = SelectorEngine.parents(target, '.nav-item')[0];
		let subMenu = SelectorEngine.findOne('.nav-list', navItem);

		slideNav.navigateTo(subMenu);

		console.log(slideNav);

		if(slideNav.options.media) {
			renderSubImage(slideNav.options.media.images[pageId] ?? slideNav.options.media.images[pageId]);
		}
		// } else {
		//	window.location.href = event.delegateTarget.getAttribute('href');
		// }
	});

	EventHandler.on(nav, 'click', '.slide-menu__backlink', (event) => {
		renderSubImage(false);
	});
};

const renderSubImage = (config) => {
	const figureEl  = SelectorEngine.findOne('.main-nav__image', pageMenu);
	const pictureEl = SelectorEngine.findOne('.main-nav__image .picture', figureEl);
	const linkEl    = SelectorEngine.findOne('.main-nav__image .figure__link', figureEl);

	Manipulator.addClass(figureEl, '-loading');

	console.log('foo');

	if(!config) {
		return;
	}

	console.log('bar');

	setTimeout(() => {
		pictureEl.innerHTML = '';
		linkEl.innerHTML = '';

		const image = Manipulator.createElementFrom(decodeURIComponent(config.image));
		const link = Manipulator.createElementFrom(decodeURIComponent(config.link));

		Manipulator.elementAppend(image, pictureEl);
		Manipulator.elementAppend(link, linkEl);

		Manipulator.removeClass(figureEl, '-loading');
	}, 250);
};

// -------
// Public
// -------

const menu = () => {
	if (pageMenu) {
		setupDrawer();
		navigation();
	}
};

// Export
export default menu;
